export const ORIGIN_PAGE = {
  web: 'auth-front-web',
  android: 'mlabs-app-mobile-android',
  ios: 'mlabs-app-mobile-ios',
  mobile: 'mlabs-app-mobile',
};

const isIosUserAgent = (userAgent) => /iPhone|iPad|iPod/i.test(userAgent);
const isAndroidUserAgent = (userAgent) => /Android/i.test(userAgent);

export const detectRegistrationOriginPage = () => {
  if (window.ReactNativeWebView) {
    const userAgent = navigator.userAgent || '';

    if (isIosUserAgent(userAgent)) {
      return ORIGIN_PAGE.ios;
    }

    if (isAndroidUserAgent(userAgent)) {
      return ORIGIN_PAGE.android;
    }

    return ORIGIN_PAGE.mobile;
  }

  return ORIGIN_PAGE.web;
};
